/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_InvalidInputs */

const en_error_organization_invalid = /** @type {(inputs: Error_Organization_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The organization cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The organization cannot be saved as it is:" |
*
* @param {Error_Organization_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_invalid = /** @type {((inputs?: Error_Organization_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_invalid(inputs)
});